import { WeatherCodeMapping } from '@reenstudio/app/core/models/weather/weather-category';

export enum WeatherCategory {
  ClearSky,
  PartlyCloudy,
  Fog,
  Drizzle,
  FreezingDrizzle,
  Rain,
  FreezingRain,
  Snowfall,
  SnowGrains,
  RainShowers,
  SnowShowers,
  Thunderstorm,
}

export const weatherDayCodeMapping: WeatherCodeMapping = {
  // Sereno
  0: {
    category: WeatherCategory.ClearSky,
    icon: 'sunny',
    description: 'Soleggiato',
  },
  // Parzialmente nuvoloso
  1: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_day',
    description: 'Parzialmente nuvoloso',
  },
  2: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_day',
    description: 'Parzialmente nuvoloso',
  },
  3: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_day',
    description: 'Parzialmente nuvoloso',
  },
  // Nebbioso
  45: {
    category: WeatherCategory.Fog,
    icon: 'foggy',
    description: 'Nebbioso',
  },
  48: {
    category: WeatherCategory.Fog,
    icon: 'foggy',
    description: 'Nebbioso',
  },
  //Pioggia debole
  51: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_day',
    description: 'Pioggia debole',
  },
  53: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_day',
    description: 'Pioggia debole',
  },
  55: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_day',
    description: 'Pioggia debole',
  },
  // Pioggia e nevicate
  56: {
    category: WeatherCategory.Drizzle,
    icon: 'weather_mix',
    description: 'Pioggia e nevicate',
  },
  57: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'weather_mix',
    description: 'Pioggia e nevicate',
  },
  // Pioggia
  61: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  63: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  65: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  80: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  81: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  82: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  // Pioggia e neve
  66: {
    category: WeatherCategory.Rain,
    icon: 'weather_hail',
    description: 'Pioggia e neve',
  },
  67: {
    category: WeatherCategory.Rain,
    icon: 'weather_hail',
    description: 'Pioggia e neve',
  },
  // Neve
  71: {
    category: WeatherCategory.Snowfall,
    icon: 'weather_snowy',
    description: 'Neve',
  },
  73: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  75: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  85: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  86: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  // Grandine
  77: {
    category: WeatherCategory.SnowGrains,
    icon: 'snowing_heavy',
    description: 'Grandine',
  },
  // Temporali
  95: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
  96: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
  99: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
};

export const weatherNightCodeMapping: WeatherCodeMapping = {
  // Sereno
  0: {
    category: WeatherCategory.ClearSky,
    icon: 'clearly_night',
    description: 'Sereno',
  },
  // Parzialmente nuvoloso
  1: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_night',
    description: 'Parzialmente nuvoloso',
  },
  2: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_night',
    description: 'Parzialmente nuvoloso',
  },
  3: {
    category: WeatherCategory.PartlyCloudy,
    icon: 'partly_cloudy_night',
    description: 'Parzialmente nuvoloso',
  },
  // Nebbioso
  45: {
    category: WeatherCategory.Fog,
    icon: 'foggy',
    description: 'Nebbioso',
  },
  48: {
    category: WeatherCategory.Fog,
    icon: 'foggy',
    description: 'Nebbioso',
  },
  //Pioggia debole
  51: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_night',
    description: 'Pioggia debole',
  },
  53: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_night',
    description: 'Pioggia debole',
  },
  55: {
    category: WeatherCategory.Drizzle,
    icon: 'rainy_night',
    description: 'Pioggia debole',
  },
  // Pioggia e nevicate
  56: {
    category: WeatherCategory.Drizzle,
    icon: 'weather_mix',
    description: 'Pioggia e nevicate',
  },
  57: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'weather_mix',
    description: 'Pioggia e nevicate',
  },
  // Pioggia
  61: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  63: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  65: {
    category: WeatherCategory.FreezingDrizzle,
    icon: 'rainy',
    description: 'Pioggia',
  },
  80: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  81: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  82: {
    category: WeatherCategory.Rain,
    icon: 'rainy',
    description: 'Pioggia',
  },
  // Pioggia e neve
  66: {
    category: WeatherCategory.Rain,
    icon: 'weather_hail',
    description: 'Pioggia e neve',
  },
  67: {
    category: WeatherCategory.Rain,
    icon: 'weather_hail',
    description: 'Pioggia e neve',
  },
  // Neve
  71: {
    category: WeatherCategory.Snowfall,
    icon: 'weather_snowy',
    description: 'Neve',
  },
  73: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  75: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  85: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  86: {
    category: WeatherCategory.Snowfall,
    icon: 'snowy',
    description: 'Neve',
  },
  // Grandine
  77: {
    category: WeatherCategory.SnowGrains,
    icon: 'snowing_heavy',
    description: 'Grandine',
  },
  // Temporali
  95: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
  96: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
  99: {
    category: WeatherCategory.Thunderstorm,
    icon: 'thunderstorm',
    description: 'Temporali',
  },
};
